import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Chip,
} from '@mui/material';
import { insiderApi } from '../../services/api';

function Positions() {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPositions();
    const interval = setInterval(loadPositions, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadPositions = async () => {
    try {
      const response = await insiderApi.getPositions();
      setPositions(response.data || []);
    } catch (err) {
      console.error('Error loading positions:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Open Positions
      </Typography>

      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Symbol</TableCell>
                <TableCell align="right">Qty</TableCell>
                <TableCell align="right">Avg Entry</TableCell>
                <TableCell align="right">Current Price</TableCell>
                <TableCell align="right">Market Value</TableCell>
                <TableCell align="right">Unrealized P/L</TableCell>
                <TableCell align="right">P/L %</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {positions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography color="text.secondary" py={3}>
                      No open positions
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                positions.map((pos) => {
                  const avgEntry = pos.avg_entry_price || 0;
                  const currentPrice = pos.current_price || 0;
                  const qty = pos.qty || 0;
                  const marketValue = pos.market_value || 0;
                  const plPct = avgEntry !== 0 ? ((currentPrice - avgEntry) / avgEntry) * 100 : 0;
                  const unrealizedPL = (currentPrice - avgEntry) * qty;
                  return (
                    <TableRow key={pos.symbol}>
                      <TableCell>
                        <Typography fontWeight="bold">{pos.symbol}</Typography>
                      </TableCell>
                      <TableCell align="right">{qty}</TableCell>
                      <TableCell align="right">
                        ${avgEntry.toFixed(2)}
                      </TableCell>
                      <TableCell align="right">
                        ${currentPrice.toFixed(2)}
                      </TableCell>
                      <TableCell align="right">
                        ${marketValue.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          sx={{ color: unrealizedPL >= 0 ? '#2e7d32' : '#d32f2f' }}
                        >
                          {unrealizedPL >= 0 ? '+' : ''}${unrealizedPL.toFixed(2)}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Chip
                          label={`${plPct >= 0 ? '+' : ''}${plPct.toFixed(2)}%`}
                          size="small"
                          sx={{
                            bgcolor: plPct >= 0 ? '#e8f5e9' : '#ffebee',
                            color: plPct >= 0 ? '#2e7d32' : '#d32f2f',
                            fontWeight: 'bold',
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default Positions;
